import Swiper from 'swiper/bundle';

let _root = this;

export default class Carousel {
  constructor(root) {
    _root = this;
    this.initCarousel();
  }

  initCarousel() {
    var swiperOptions = {
      //loop: true,
      speed: 1200,
      grabCursor: false,
      slidesPerView: 1,
      spaceBetween: 20,
      autoplay: {
          delay: 4000,
          disableOnInteraction: true,
      },
      // autoHeight: true, //enable auto height
      init: false,
      pagination: {
        el: '.carousel-swiper .swiper-pagination',
        clickable: true,
        renderBullet: function(index, className) {
          return '<span class="' + className + '">' + (index + 1) + '</span>';
        }
      },
      breakpoints: {
        500: {
          slidesPerView: 1,
          spaceBetween: 30,
        },
        700: {
          slidesPerView: 2, 
          spaceBetween: 30,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
        1400: {
          slidesPerView: 4,
          spaceBetween: 30,
        },
      },
    };

    document.querySelectorAll('.carousel-swiper').forEach((_swiperContainer) => {
      var swiper = new Swiper(_swiperContainer, swiperOptions);
      if ('undefined' != typeof _swiperContainer && null != _swiperContainer) {
        swiper.init();
      }
    });
  }
}
